import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <>
      <div className="py-3 bg-[#f7d7d759]">
        <div className="flex gap-10 justify-evenly">
          <div>© 2025 Dhvani Terefabs Exports Private Limited. All rights reserved.</div>
          <div>
            <NavLink
              to="/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer underline"
            >
              Terms & Conditions
            </NavLink>
            &nbsp; | &nbsp;
            <NavLink
              to="/privacy-policy"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer underline"
            >
              Privacy Policy
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
